<template>
    <div class="d-flex">
        <navigator class="navigator" :flag="navFlag" />
        <OnboardingWrapper class="test-wrapper">
            <div class="test-page">
                <div class="title-header">
                    <h2> My Projects </h2>
                </div>

                <div class="view" v-if="userType === 0">
                    <div v-if="!this.projectID" class="nostream">
                        <h5 class="noTest">NO ACTIVE PROJECTS</h5>
                        <h6>Please navigate to <router-link to="/">Dashboard</router-link> and select a project to start</h6>
                    </div>

                    <div v-if="!this.projectID" class="noTestVisual">
                        <img src="../../assets/Not Found.png" class="noTestImage">
                        <div class="noTestText">No tests found (´；ω；`) </div>
                    </div>

                    <div v-if="this.projectID" class="testerContainer">
                        <div id="testerVideoContainer">
                            <div id="testerVideoDisplay"></div>
                        </div>
                        <div class="notes-button red" @click="endStream">End Test</div>
                    </div>
                </div>

                <div class="view" v-if="userType === 1">
                    <div v-if="!projectID || projectID === ''" class="nostream">
                        <h5 class="noTest">NO ACTIVE TESTING SESSIONS</h5>
                        <h6>Please navigate to <router-link to="/dashboard">Dashboard</router-link> and select a project that has an
                            active Test Session</h6>
                    </div>

                    <!-- <div v-if="!this.projectID" class="noTestVisual">
                        <img src="../../assets/Not Found.png" class="noTestImage">
                        <div class="noTestText">No tests found (´；ω；`) </div>
                    </div> -->

                    <div v-if="this.projectID" class="developerContainer">
                        <div id="developerVideoContainer">
                            <div v-if="!this.activeStream" class="nostream">
                                <h1>Test Session Complete</h1>
                                <h5>Please submit any final notes and then leave the session.</h5>
                            </div>
                            <div id="developerVideoDisplay"></div>
                            <div class="notes-button red" @click="leaveStream">Leave</div>
                        </div>

                        <noteEntry v-if="this.sessionID" :testFocus="this.testFocus" :notes="this.notes"
                            @saveNote="this.saveNote" @saveFocus="this.updateFocus"></noteEntry>
                    </div>
                </div>
            </div>
        </OnboardingWrapper>
    </div>
</template>

<script>
import navigator from '../layout/NavBarNew.vue'
import noteEntry from './NoteEntryComponent.vue'
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue'
import RTCMultiConnection from 'rtcmulticonnection'
import router from '../../router';
import GameTesting from "../../Firestore/GameTesting";
import { onboardingService } from '@/services/OnboardingService';
import { initializePageOnboarding } from '@/services/onboardingConfigs';

export default {
    name: "test",
    components: {
        navigator,
        router,
        noteEntry,
        OnboardingWrapper
    },
    data() {
        return {
            navFlag: 1,
            userType: window.localStorage.getItem("userType") ? window.localStorage.getItem("userType") : -1,
            activeStream: true,
            sessionID: this.$route.params.sessionID || null,
            projectID: this.$route.params.projectID || "",
            connection: null,
            notes: [],
            testFocus: "",
            ready: true,
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.sessionID && this.userType === 0) {
            if (!window.confirm("Leave without saving?")) {
                return;
            }
            if (this.userType === 0) this.endStream();
        }
        next();
    },
    mounted() {
        let socket_io = document.createElement('script')
        socket_io.setAttribute('src', 'https://cdn.socket.io/4.5.4/socket.io.min.js')
        document.head.appendChild(socket_io)

        if (window.localStorage.getItem("userType")) {
            this.userType = parseInt(window.localStorage.getItem("userType"));

            this.connection = new RTCMultiConnection();
            this.connection.socketURL = 'https://muazkhan.com:9001/';
            this.connection.socketMessageEvent = 'test-session';

            this.connection.session = {
                audio: true,
                screen: true,
                oneway: true
            };

            this.connection.sdpConstraints.mandatory = {
                OfferToReceiveAudio: false,
                OfferToReceiveVideo: false
            };

            this.$nextTick(function () {
                this.sessionID = this.$route.params.sessionID || null;
                this.projectID = this.$route.params.projectID || "";

                if (this.userType === 0) this.connection.videosContainer = document.getElementById("testerVideoDisplay");
                else if (this.userType === 1) this.connection.videosContainer = document.getElementById("developerVideoDisplay");
            });

            if (this.projectID) {
                this.validateSession();
                this.getNotes();
            }

            let that = this;
            this.connection.onMediaError = function (error, constraints) {
                that.endStream();
            };

            this.connection.onstreamended = function (event) {
                var mediaElement = document.getElementsByTagName('video')[0];
                if (mediaElement) {
                    mediaElement.parentNode.removeChild(mediaElement);
                }
                that.$set(that.$data, 'activeStream', false);
            };

            // Initialize Onboarding
            this.$nextTick(() => {
                initializePageOnboarding(
                    'test',
                    this.userType,
                    onboardingService,
                    this.$store
                );
            });
        } else {
            this.$router.push({
                name: 'login',
            })
        }
    },
    methods: {
        endStream() {
            GameTesting.testerEndTestSession(this.sessionID)
                .then(res => {
                    this.activeStream = false;
                    this.$set(this.$data, 'sessionID', null);
                    this.$router.push({
                        name: 'dashboard',
                    }).then(() => this.$router.go());
                })
                .catch(e => console.log(e));
        },

        leaveStream() {
            this.$set(this.$data, 'sessionID', null);
            if (this.activeStream) {
                this.activeStream = false;
                this.$router.push({
                    name: 'dashboard'
                }).then(() => this.$router.go());
            } else {
                this.activeStream = false;
                localStorage.setItem('gameId', this.projectID);
                window.localStorage.setItem("gameDetailIndex", 1);
                this.$router.push({
                    name: 'gamedetail',
                }).then(() => this.$router.go());
            }
        },

        startStream() {
            this.activeStream = true;
            this.connection.open(this.sessionID, () => console.log("started!"));
        },

        validateSession() {
            if (this.userType === 0) {
                GameTesting.checkGameHasActiveTestSession(this.projectID, window.localStorage.getItem("userId"))
                    .then((res) => {
                        if (!res.data.activeSession) {
                            GameTesting.createTestSession(this.projectID, window.localStorage.getItem("userId"), null)
                                .then(res => {
                                    const newSessionID = res.data;
                                    GameTesting.testerStartTestSession(newSessionID)
                                        .then(res => {
                                            this.$set(this.$data, 'sessionID', newSessionID);
                                            this.startStream();
                                        })
                                        .catch(e => console.log(e));
                                })
                                .catch(e => console.log(e));
                        }
                    })
                    .catch(e => console.log(e));
            } else if (this.userType === 1) {
                GameTesting.checkGameHasActiveTestSession(this.projectID, null)
                    .then((res) => {
                        if (res.success && res.data.activeSession) {
                            GameTesting.joinTestSession(res.data.session.sessionID, window.localStorage.getItem("userId"))
                                .then(res2 => {
                                    const newSessionID = res.data.session.sessionID;
                                    this.$set(this.$data, 'testFocus', res.data.session.testFocus);
                                    this.notes = res.data.session.notes;
                                    this.$set(this.$data, 'sessionID', newSessionID);
                                    this.joinStream();
                                })
                                .catch(e => console.log("joinTestSession error: ", e));
                        }
                    })
                    .catch(e => console.log("checkGameHasActiveTestSession error: ", e));
            }
        },

        joinStream() {
            this.activeStream = true;
            this.connection.join(this.sessionID);
        },

        getNotes() {
            GameTesting.getTestSessionNotes(this.sessionID)
                .then(res => {
                    this.notes = res.data;
                })
                .catch(e => console.log(e));
        },

        updateFocus(newFocus) {
            GameTesting.updateTestSessionFocus(this.sessionID, newFocus)
                .then(res => {
                    this.$set(this.$data, 'testFocus', newFocus);
                })
                .catch(e => console.log(e));
        },

        saveNote(note) {
            GameTesting.addSessionNote(this.sessionID, note)
                .then(res => {
                    this.getNotes();
                })
                .catch(e => console.log(e));
        },
    },
    watch: {
        sessionID(newVal, oldVal) {
            if (oldVal !== null && newVal === null) {
                this.activeStream = false;
            } else if (oldVal === null && newVal !== null) {
                this.activeStream = true;
            }
        },
    },
}
</script>

<style scoped>
/* Base Page Layout */
.test-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    background-color: #EEEEEE;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Matches modern web standards */
}

/* Header - Matches Dashboard exactly */
.title-header {
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 100%;
    box-shadow: 0 4px 10px -6px grey;
    z-index: 10;
}

.title-header h2 {
    color: #FF7222;
    font-weight: bold;
    font-size: 2rem;
    margin: 0;
}

/* Main View Container */
.view {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
}

/* Centered Content Cards (The "Modern" Look) */
.nostream, .noTestVisual {
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
    text-align: center;
    max-width: 600px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* Typography Updates */
.noTest {
    color: #FF7222;
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 15px;
}

.noTestText {
    color: #888;
    font-size: 1.1rem;
    margin-top: 15px;
}

h6 {
    color: #555;
    line-height: 1.5;
}

/* Video Containers */
.testerContainer, .developerContainer {
    width: 90%;
    max-width: 1200px;
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

#testerVideoDisplay, #developerVideoDisplay {
    background: #000;
    border-radius: 8px;
    min-height: 400px;
    margin-bottom: 20px;
    overflow: hidden;
}

/* Modernized Buttons */
.notes-button {
    display: inline-block;
    padding: 10px 25px;
    height: auto;
    background: #666464;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    font-size: 14px;
    color: white;
    cursor: pointer;
    transition: transform 0.2s, background 0.2s;
}

.notes-button:hover {
    transform: translateY(-2px);
}

.red {
    background: #dc3545; /* Modern red */
}

.red:hover {
    background: #bd2130;
}

/* Image styling */
.noTestImage {
    width: 120px;
    margin-bottom: 20px;
    opacity: 0.8;
}

/* Helper for router links */
a {
    color: #FF7222;
    text-decoration: none;
    font-weight: bold;
}

a:hover {
    text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/test-session/TestSession.vue